import { contractAction } from "./action"

export const initialState = {
  signState: "loading",
  signLists: null,
  allContract: [],
  singleSign: false,
}

export function contractReducer(state = { ...initialState }, action) {
  switch (action.type) {
    case contractAction.SET_CONTRACT_STATE: {
      return Object.assign({}, state, action.payload)
    }

    default:
      return state
  }
}
